import { call, put, takeLatest } from 'redux-saga/effects';

import { getTaxExemptions } from '../../services/API';
import { actionTypes, taxExemptionsRequestSuccess, taxExemptionsRequestFailure } from './actions';

function* getTaxExemptionsWorker() {
  const response = yield call(getTaxExemptions);
  yield put(
    response.isOk
      ? taxExemptionsRequestSuccess(response.data)
      : taxExemptionsRequestFailure(response.error),
  );
}

export default function* taxExemptionsSaga() {
  yield takeLatest(actionTypes.TAX_EXEMPTIONS_REQUEST_START, getTaxExemptionsWorker);
}
